import GlassCard from "../../components/GlassCard";
import { warningsContent } from "../data/warningsContent";
import { useCurrentLang } from "../../hooks/useCurrentLang";

/**
 * @typedef {|
 * "MissingPersonalInfo"
 * | "EmailNotVerified"
 * | "SubscriptionEndingSoon"
 * | "PaymentFailed"
 * | "UnfinishedSession"
 * | "UnsavedChanges"
 * | "MaintenanceBreakUpcoming"
 * | "ServiceDegraded"
 * | "PermissionMissing"
 * | "SuspiciousLoginDetected"
 * | "NoActivePlanForUser"
 * } WarningType
 */

/**
 * @param {{ warningType: WarningType, data?: Record<string, unknown> }} props
 */
export default function Warning({ warningType, data = {} }) {
  const currentLang = useCurrentLang();
  const t = warningsContent[currentLang]?.[warningType];

  if (!t) return null;

  const cardStyle = {
    padding: "10px",
    maxWidth: "775px",
    marginLeft: "50px",
    marginBottom: "25px",
    borderColor: "#ef4444",
  };

  const badgeStyle = {
    fontSize: "0.8rem",
    textTransform: "uppercase",
    letterSpacing: "0.08em",
    opacity: 0.7,
    background: "rgba(239, 68, 68, 0.6)",
    borderRadius: "99px",
    padding: "3px",
    display: "inline-block",
    marginBottom: "10px",
  };

  const warningTypesWithHelpEmail = new Set([
    "MissingPersonalInfo",
    "EmailNotVerified",
    "SubscriptionEndingSoon",
    "PaymentFailed",
    "UnfinishedSession",
    "UnsavedChanges",
    "MaintenanceBreakUpcoming",
    "ServiceDegraded",
    "PermissionMissing",
    "SuspiciousLoginDetected",
    "NoActivePlanForUser",
  ]);

  const showHelpEmail = warningTypesWithHelpEmail.has(warningType);

  return (
    <GlassCard style={cardStyle}>
      <div style={badgeStyle}>{t.label}</div>
      <h1>{t.title}</h1>
      <p>
        {t.description}
        {showHelpEmail && (
          <>
            {" "}
            <a href="mailto:help@revimo.eu" style={{color:"rgb(3, 114, 199)"}}>help@revimo.eu</a>.
          </>
        )}
      </p>
    </GlassCard>
  );
}